<script setup lang="ts">
import { Button, Tooltip } from '@collector/shared-ui'
import type { EventScout } from '@collector/sportsapi-client-legacy'

import LiveEventScoutsNames from './LiveEventScoutsNames.vue'

interface Props {
  eventScouts: EventScout[]
}

defineProps<Props>()
</script>

<template>
  <div class="z-10 flex items-center">
    <LiveEventScoutsNames
      class="hidden @lg:flex"
      :eventScouts
    />

    <Tooltip class="inline-block @lg:hidden">
      <Button
        class="border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3"
        icon="user"
        size="sm"
        square
      />
      <template #tooltip>
        <LiveEventScoutsNames :eventScouts />
      </template>
    </Tooltip>
  </div>
</template>
